import React from 'react';
import OrderBookInfo from '../../../components/projectmng/obtainorder/OrderBookInfo';

const OrderBookInfoContainer = ({ orderInfo, project, isLink }) => {
  return (
    <OrderBookInfo orderInfo={orderInfo} project={project} isLink={isLink} />
  );
};

export default OrderBookInfoContainer;
